import Footer from './components/Footer'
export { Footer }
export * from './components/svg'
export default Footer
